var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tick-circle",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "tick-circle-1",
    d: "M65.9646672,0 L67.1139315,0.00979131948 C102.66429,0.615965783 131.376627,29.2920137 131.989986,64.8400974 L132,66.0016825 L131.990198,67.1508306 C131.383337,102.697278 102.675041,131.377332 67.1262637,131.989997 L65.9646672,132 L64.8155302,131.990209 C28.8834016,131.377446 0,102.081313 0,66.0016825 C0,29.5348612 29.5012109,0 65.9646672,0 Z M65.9983175,13.2010095 L64.9335768,13.2115177 C36.2541524,13.7780755 13.2010095,37.1826697 13.2010095,66.0016825 C13.2010095,94.8173713 36.2541524,118.221925 64.9335768,118.788482 L65.9983175,118.79899 L67.0631798,118.788482 C95.3873143,118.229007 118.221782,95.3989167 118.788218,67.0797003 L118.79899,66.0016825 L118.788482,64.9368202 C118.221925,36.2541524 94.8173303,13.2010095 65.9983175,13.2010095 Z M91.0105794,37.8902287 L104.056798,50.6268641 L56.3608739,96.5561476 L27.9465674,69.0672241 L40.9894206,56.3272236 L56.3608739,71.0761465 L91.0105794,37.8902287 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tick-circle-2",
    fill: "none",
    fillRule: "evenodd",
    className: "fill-selector"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "tick-circle-3",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    id: "tick-circle-4",
    xlinkHref: "#tick-circle-1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "tick-circle-5",
    fill: "#737373",
    points: "-12 144 144 144 144 -12 -12 -12",
    mask: "url(#tick-circle-3)",
    className: "fill-selector"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "tick-circle-6",
    fill: "#FFF308",
    points: "-24 156 156 156 156 -24 -24 -24",
    mask: "url(#tick-circle-3)",
    className: "fill-selector"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick-circle.b90eccb5fb6194ef1c1c6da266b764b4.svg";
export { ForwardRef as ReactComponent };